import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { PrimaryButton } from '../ui/PrimaryButton';
import { SectionTag } from '../ui/SectionTag';
import { scrollToId } from '../../utils/scroll';
import { forYouPoints } from '../../data/forYou';
export function ForYou() {
  return <section className="bg-white py-10 sm:py-14" data-id="element-88" data-mp="2tasppah0r7b5">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-89" data-mp="2t7dc6c2zu6bu">
        <SectionTag icon="👀" data-id="element-90" data-mp="3gztr4drfpi6x">Esto es para ti si…</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-91" data-mp="3l16yisa6dtfy">
          ¿Te suena alguna de estas escenas?
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-92" data-mp="373iajbkta66o">
          Si te identificas con 2 o más, VOLEY-PRO 360 fue diseñado exactamente para ti.
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-6xl gap-4 px-4 sm:grid-cols-2 sm:px-6 lg:grid-cols-3" data-id="element-93" data-mp="1vo20gc3okch2">
        {forYouPoints.map((point, i) => <m.div key={point.n} initial={{
        opacity: 0,
        y: 14
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.4,
        delay: i % 3 * 0.08
      }} className="relative flex flex-col rounded-2xl border border-gris-claro bg-bg-secondary p-6" data-id="element-94" data-mp="3p8seh5cm3kjz" data-mpi={i}>
            <div className="flex items-center justify-between" data-id="element-95" data-mp="3uazuq74h5ms4">
              <span className="font-heading text-3xl font-bold text-gris-claro" data-id="element-96" data-mp="c1pigiqg4m4r">{point.n}</span>
              <span className="text-2xl" aria-hidden="true" data-id="element-97" data-mp="80nke589mg4d">
                {point.emoji}
              </span>
            </div>
            <span className="mt-3 inline-block w-fit rounded-full bg-naranja/10 px-2.5 py-0.5 text-[11px] font-semibold uppercase tracking-wide text-naranja" data-id="element-98" data-mp="luxyztqjstwp">
              {point.tag}
            </span>
            <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-azul-dark" data-id="element-99" data-mp="voww2ebrlnhs">
              {point.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-muted" data-id="element-100" data-mp="xvwbnj5tr8cf">{point.text}</p>
            <div className="mt-4 flex h-6 w-6 items-center justify-center rounded-full bg-success/15" data-id="element-101" data-mp="12toeh880ceve">
              <CheckIcon size={14} className="text-success" data-id="element-102" data-mp="17t0yzmbep9ut" />
            </div>
          </m.div>)}
      </div>

      <div className="mx-auto mt-8 max-w-2xl px-4 text-center sm:px-6" data-id="element-103" data-mp="1cl2fxljiror6">
        <p className="text-base leading-relaxed text-gris-oscuro sm:text-lg" data-id="element-104" data-mp="1hjn7yxomb24j">
          Entrena con la seguridad de quien llega a la pista sabiendo exactamente qué quiere trabajar, cómo
          corregirlo y cómo conectarlo con el partido del sábado.
        </p>
        <div className="mt-6 flex justify-center" data-id="element-105" data-mp="1qhpji75z9d62">
          <PrimaryButton onClick={() => scrollToId('oferta-base')} data-id="element-106" data-mp="1vhtyfsr8lzu6">Quiero Voley-Pro 360</PrimaryButton>
        </div>
      </div>
    </section>;
}